var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 1.75H4.125C2.81332 1.75 1.75 2.81332 1.75 4.125V27.875C1.75 29.1867 2.81332 30.25 4.125 30.25H27.875C29.1867 30.25 30.25 29.1867 30.25 27.875V4.125C30.25 2.81332 29.1867 1.75 27.875 1.75Z",
    stroke: "#25A249",
    strokeWidth: 2.185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6248 10.4583H7.2915V21.5416H13.229M7.2915 15.9999H13.229M17.5832 12.0416V21.5416V16.3958C17.5832 15.4509 17.9585 14.5448 18.6266 13.8767C19.2947 13.2086 20.2008 12.8333 21.1457 12.8333C22.0905 12.8333 22.9966 13.2086 23.6647 13.8767C24.3328 14.5448 24.7082 15.4509 24.7082 16.3958V21.5416",
    stroke: "#25A249",
    strokeWidth: 2.185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.c9802f76d20627830fa4fe83b37f7fac.svg";
export { ForwardRef as ReactComponent };